<template>
  <div class="status" :class="[{ 'no--dot': !hasDot }]">
    <span
      v-if="hasDot"
      class="status-dot"
      :class="['status-dot--' + type]"
    ></span>
    <span class="status-text" :class="['status-text--' + type]">
      <slot></slot>
    </span>
  </div>
</template>
<script>
export default {
  name: "StatusTag",
  props: {
    type: {
      type: String,
      default: "primary"
    },
    hasDot: {
      type: Boolean,
      default: true
    }
  }
};
</script>
<style lang="scss" scoped>
.status {
  &-dot {
    margin-right: 4px;
    display: inline-block;
    vertical-align: middle;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    &--primary {
      background-color: #409eff;
    }

    &--success {
      background-color: #67c23a;
    }

    &--warning {
      background-color: #e6a23c;
    }

    &--danger {
      background-color: #f56c6c;
    }

    &--info {
      background-color: #909399;
    }
  }
}
.no--dot {
  .status-text {
    &--primary {
      color: #409eff;
    }

    &--success {
      color: #67c23a;
    }

    &--warning {
      color: #e6a23c;
    }

    &--danger {
      color: #f56c6c;
    }

    &--info {
      color: #909399;
    }
  }
}
</style>
